import axios from 'axios'
export default {
  state: {
    productItem: [],
    productName: '',
    templateName: '',
    designerName: '',
    price: '',
    priceRange: false,
    productIntroDesc: [],
    productNotes: '',
    productPattern: [],
    productFeature: [],
    purchaseNotice: '',
    choosedPatterenID: null,
    editLink: '',
    recommendedDesigner: [],
    recommendedPrdouct: [],
    productItemAlbum: [],
    productItemFeature: [],
    // 折扣價
    discountprice: null,
    discountpriceForecolor: null,
    discountpriceBgcolor: null,
    // 提示文字和顏色
    note: null,
    noteForecolor: null,
    noteBgcolor: null,
    enableEdit: null,
    editorPrePage: null
  },
  actions: {
    getDesignerItem ({commit}, {designerItemId}) {
      commit('LOADING', true, {root: true})
      commit('clearItem') // jason
      let API_PATH = process.env.API
      return axios.get(`${API_PATH}design/getdetail/${designerItemId}`).then(response => {
        let {productItem, productIntroDesc, productNotes, productPattern, productFeature, purchaseNotice, designerMaster, recommendedDesigner, recommendedPrdouct, productItemAlbum, productItemFeature} = response.data.data
        commit('init', {productItem, productIntroDesc, productNotes, productPattern, productFeature, purchaseNotice, designerMaster, recommendedDesigner, recommendedPrdouct, productItemAlbum, productItemFeature})
        commit('LOADING', false, {root: true})
      }).catch(error => {
        console.log(error)
      })
    }
  },
  mutations: {
    init (state, {productItem, productIntroDesc, productNotes, productPattern, productFeature, purchaseNotice, designerMaster, recommendedDesigner, recommendedPrdouct, productItemAlbum, productItemFeature}) {
      state.productItem = productItem
      state.productName = productItem[0].productName
      state.templateName = productItem[0].templateName
      // 2022/10/25, jamei, state.price = productItem[0].price
      // 判斷價格是否有起
      let price = productItem[0].price
      if (price[price.length - 1] === '起') {
        state.price = price.substring(0, price.length - 1)
        state.priceRange = true
      } else {
        state.price = price
        state.priceRange = false
      }
      state.choosedPatterenID = productItem[0].Id
      state.editLink = productItem[0].editLink
      state.designerMaster = designerMaster
      state.productIntroDesc = productIntroDesc
      state.productNotes = productNotes
      state.productPattern = productPattern
      state.productFeature = productFeature
      state.purchaseNotice = purchaseNotice
      state.designerName = designerMaster[0].designerName
      state.recommendedDesigner = recommendedDesigner
      state.recommendedPrdouct = recommendedPrdouct
      state.productItemAlbum = productItemAlbum
      state.productItemFeature = productItemFeature
      state.discountprice = productItem[0].discountprice
      state.discountpriceForecolor = productItem[0].discountpriceForecolor
      state.discountpriceBgcolor = productItem[0].discountpriceBgcolor
      state.note = productItem[0].note
      state.noteForecolor = productItem[0].noteForecolor
      state.noteBgcolor = productItem[0].noteBgcolor
      state.enableEdit = productItem[0].enableEdit
      state.editorPrePage = productItem[0].editorPrePage
    },
    choosedPatteren (state, {Id, editLink}) {
      state.choosedPatterenID = Id
      state.editLink = editLink
    },
    clearItem (state) {
      state.productItem = []
      state.productIntroDesc = []
      state.productPattern = []
      state.productFeature = []
      state.recommendedDesigner = []
      state.recommendedPrdouct = []
      state.productItemAlbum = []
      state.productItemFeature = []
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/designerItem.js